import { render, staticRenderFns } from "./ContentUeberMich.vue?vue&type=template&id=0289cd90&scoped=true&"
import script from "./ContentUeberMich.vue?vue&type=script&lang=js&"
export * from "./ContentUeberMich.vue?vue&type=script&lang=js&"
import style0 from "./ContentUeberMich.vue?vue&type=style&index=0&id=0289cd90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0289cd90",
  null
  
)

export default component.exports